require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./transgender-booking-policy.json") })
        }
      }, "path---transgender-booking-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---transgender-booking-policy!./.cache/json/transgender-booking-policy.json
// module id = 1058
// module chunks = 231608221292675